import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const financialApi = createApi({
  reducerPath: 'financialApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Invoice', 'Revenue'],
  endpoints: (builder) => ({
    getInvoices: builder.query<unknown[], string | void>({
      query: (status) => ({ url: 'financials/invoices', params: status ? { status } : {} }),
      providesTags: ['Invoice'],
    }),
    getInvoice: builder.query<unknown, string>({
      query: (id) => `financials/invoices/${id}`,
      providesTags: ['Invoice'],
    }),
    getRevenueReport: builder.query<Record<string, unknown>, void>({
      query: () => 'financials/revenue',
      providesTags: ['Revenue'],
    }),
    updateInvoiceStatus: builder.mutation<unknown, { id: string; status: string }>({
      query: ({ id, status }) => ({
        url: `financials/invoices/${id}/status`,
        method: 'PUT',
        body: { status },
      }),
      invalidatesTags: ['Invoice', 'Revenue'],
    }),
  }),
});

export const {
  useGetInvoicesQuery,
  useGetInvoiceQuery,
  useGetRevenueReportQuery,
  useUpdateInvoiceStatusMutation,
} = financialApi;
